import React from "react"

import {APhoneField, APhoneFieldDnclStatusEnum} from "../services/types.generated.ts"

export const AnonymizedEmail: React.FC<{email: string | null | undefined}> = ({email}) => {
  if (email == null) {
    return "-"
  }

  const split = email.split("@")
  const anonymized = email.includes("@") && split[0] !== "info" ? split[0] : ""
  const notAnonymized = email.substring(anonymized.length)

  return (
    <>
      {anonymized.length > 0 && <span className={"text-cr-grey-50"}>{anonymized}</span>}
      {notAnonymized.length > 0 && <span>{notAnonymized}</span>}
    </>
  )
}

export const AnonymizedPhone: React.FC<{phone: string | null | undefined}> = ({phone}) => {
  if (phone == null) {
    return "-"
  }

  const notAnonymized = phone.substring(0, 4)
  const anonymized = phone.substring(notAnonymized.length)

  return (
    <>
      {notAnonymized.length > 0 && <span>{notAnonymized}</span>}
      {anonymized.length > 0 && <span className={"text-cr-grey-50"}>{anonymized}</span>}
    </>
  )
}

export const PhoneNumberCell = ({row}: {row: {phone_number?: APhoneField | string | null; anonymized?: boolean}}) => {
  const phoneField = row.phone_number
  const number = typeof phoneField === "string" ? phoneField : (phoneField?.number ?? null)

  if (!number) {
    return <span>-</span>
  }

  if (isAnonymized(row)) {
    return (
      <span>
        <AnonymizedPhone phone={number} />
      </span>
    )
  }

  const dnclStatus = typeof phoneField === "object" && phoneField != null ? phoneField.dncl_status : undefined
  const colorClass =
    dnclStatus === APhoneFieldDnclStatusEnum.Listed
      ? "text-cr-red"
      : dnclStatus === APhoneFieldDnclStatusEnum.Failed
        ? "text-cr-yellow"
        : ""

  return <span className={colorClass}>{number}</span>
}

export const EmailCell = ({row}: {row: {email?: string | null; anonymized?: boolean; info_contact?: boolean}}) => {
  if (!row.email) {
    return <span>-</span>
  }

  if (isAnonymized(row) && !isInfoContact(row)) {
    return (
      <span>
        <AnonymizedEmail email={row.email} />
      </span>
    )
  }

  return <span>{row.email}</span>
}

export function isAnonymized<T extends Record<any, any>>(obj: T): obj is T & {anonymized: true} {
  return "anonymized" in obj && obj.anonymized === true
}

export function isInfoContact<T extends Record<any, any>>(obj: T): obj is T & {info_contact: true} {
  return "info_contact" in obj && obj.info_contact === true
}
